<template>
  <v-card class="pa-3">
    <v-card-title>
      Bundle Hinzufügen
    </v-card-title>
    <v-form @submit.prevent="create()">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="createBundleForm.name"
            outlined
            label="Bundle Name"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="createBundleForm.tax_id"
            :items="taxes"
            item-value="id"
            item-text="name"
            outlined
            label="Steuern"
          />
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="createBundleForm.description"
            outlined
            label="Beschreibung"
          />
        </v-col>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn type="submit" color="primary">
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
export default {
   name: 'BundleCreate',
   props: {
      taxes: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         createBundleForm: this.$inertia.form({
            name: null,
            tax_id: null,
            description: null
         })
      }
   },
   methods: {
      create () {
         this.createBundleForm.post(this.route('bundle.store'), {
            onSuccess: () => {
               this.createBundleForm.reset()
               this.$emit('updated')
            }
         })
      }
   }
}
</script>

<style></style>
